import { CAMERA_TRACK_LIMITS, transitionWindow } from '../../domain/camera-keyframes';
import { JogRangeControl } from '../../components/JogRangeControl';
import type { CameraAnimation } from './use-camera-animation';
import { KeyframeTimingControls } from '../KeyframeTimingControls';
import { cameraKeyTiming } from '../keyframe-timing';

export function CameraKeyInspector({ animation, duration }: { animation: CameraAnimation; duration: number }) {
  const { tracks, selected, key } = animation;
  const previous = selected && key ? tracks?.[selected.axis]?.filter(item => item.seconds < key.seconds).at(-1) : undefined;
  const window = key ? transitionWindow(key, previous?.seconds ?? 0) : undefined;
  return <>
      {selected && key && <div className="attribute-key-inspector" aria-label="Selected attribute key">
        <h2>{CAMERA_TRACK_LIMITS[selected.axis].label} key</h2>
        {key.automatic && <p>Automatic at this key. Earlier authored values are retained.</p>}
        {tracks?.version === 1 && <p>Legacy interval timing. Editing converts these tracks while retaining their interpolation.</p>}
        <JogRangeControl label="Value" disabled={selected.axis === 'rotation' && animation.headingLocked} unit={CAMERA_TRACK_LIMITS[selected.axis].unit} min={CAMERA_TRACK_LIMITS[selected.axis].min}
          max={CAMERA_TRACK_LIMITS[selected.axis].max} step={CAMERA_TRACK_LIMITS[selected.axis].step} value={key.value}
          onChange={value => animation.patch(selected.axis, selected.id, { value })} />
        <KeyframeTimingControls seconds={key.seconds} duration={duration} timing={cameraKeyTiming(key)} start={window!.start} effectiveDuration={window!.duration}
          onMove={seconds => animation.patch(selected.axis, selected.id, { seconds })}
          onTiming={change => animation.patch(selected.axis, selected.id, change)}
          onDelete={() => animation.remove(selected.axis, selected.id)} onDeselect={animation.clear} />
      </div>}
  </>;
}
